import { compose, filter, length, path } from 'ramda'

const unreadNotifications = compose(filter(path(['attributes', 'new'])), path(['entities']))

export default {
  unreadNotifications,
  unreadNotificationCount: compose(length, unreadNotifications),
}
